// The main store used for the Receipt section
export default {
	namespaced: true,
	state: () => ({
		cartData: {}, // the cart data from the API
		miniCart: false, // mobile cart visibility
		receiptLoading: false, // receipt skeleton loading
	}),

    getters: {
        hasGiftCard(state) {
            return state.cartData.addOns?.promo?.giftCard?.length > 0;
        },
        giftCardName() {
            return 'Enjoy 2 months of savings*'
        },
        giftCardPrice() {
            return '2 months free'
        },
        promoPrice() {
            return '1 month free'
        }
    },

	mutations: {
		UPDATE_CART (state, payload) {
			state.cartData = { ...payload }
		},
		TOGGLE_MINI_CART (state, payload) {
			state.miniCart = payload
		},
		SET_RECEIPT_LOADING(state, payload) {
			state.receiptLoading = payload
		}
	},

	actions: {
		updateCart({ commit }, payload){
			commit('UPDATE_CART', payload)
		},
		toggleMiniCart ({ state, commit }, payload) {
			// only commit if the value will indeed change, to avoid polluting vuex logs
			if (state.miniCart !== payload) {
				commit('TOGGLE_MINI_CART', payload)
			}
		},
		setReceiptLoading({ commit }, payload){
			commit('SET_RECEIPT_LOADING', payload)
		},
	},
}
